import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { moduleLabel } from '../lib/permissions';
import { Lock } from 'lucide-react';

/**
 * Wrap a route element with a permission gate. Renders a friendly
 * "Access denied" panel instead of the child when the current user
 * lacks the required permission.
 */
export default function RequirePerm({ module, action = 'view', children }) {
    const { user, loading, can } = useAuth();
    if (loading) return null;
    if (!user) return null;
    if (can(module, action)) return children;
    return (
        <div className="px-8 py-16 flex flex-col items-center text-center" data-testid="access-denied">
            <div className="w-12 h-12 rounded-full bg-[color:var(--bm-bg-mute)] flex items-center justify-center mb-3">
                <Lock size={20} className="text-[color:var(--bm-text-muted)]" />
            </div>
            <div className="text-[16px] font-semibold">Access denied</div>
            <div className="text-[13px] text-[color:var(--bm-text-muted)] mt-1.5 max-w-md">
                You don't have permission to {action} <span className="font-medium">{moduleLabel(module)}</span>.
                Ask an administrator to update your role.
            </div>
        </div>
    );
}
